export default function () {
    const entityEvent = useEntityEvent();

    async function get(filter) {
        let events = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('events', filter);
            events = data.events.map((event) => {
                return entityEvent.build(event);
            });
        } catch (e) {
            error = useApiError(e);
        }
        return {events, error};
    }

    return {get};
}
